class AlertModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleHide = this.handleHide.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.state = {
      showModal:
        this.props.showModal === undefined ? true : this.props.showModal,
      // this.props.showModal === undefined ? true : this.props.showModal
    };
  }

  handleHide() {
    this.setState({ showModal: false });
    this.props.handleHide(false);
  }

  handleShow() {
    this.setState({ showModal: this.props.showModal });
  }

  componentWillReceiveProps(props) {
    this.setState({ showModal: props.showModal });
  }

  render() {
    return (
      <div id="modal-wrap">
        <Modal
          show={this.state.showModal}
          container={this.props.container}
          onHide={this.handleHide}
          bsSize="large"
          backdrop="static"
          aria-labelledby="contained-modal-title-sm"
        >
          <Modal.Header>{this.props.title}</Modal.Header>
          <Modal.Body>
            <div className="body-container">
              <div className="col-xs-12 messages">{this.props.msg}</div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className={`${
                this.props.planVital
                  ? "btn btn-default-planvital"
                  : "btn btn-default"
              }`}
              onClick={this.handleHide}
            >
              Aceptar
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const Modal = ReactBootstrap.Modal;
const Button = ReactBootstrap.Button;

export default AlertModal;
